var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0  industry-page"},[_c('h1',{staticClass:"d-lg-none show-title mb-10"},[_vm._v(_vm._s(_vm.content.title))]),_c('p',{staticClass:"industry-text"},[_vm._v(_vm._s(_vm.content.text1))])])}
var staticRenderFns = []

export { render, staticRenderFns }